import { render, staticRenderFns } from "./setupMfa.vue?vue&type=template&id=84f34362&"
import script from "./setupMfa.vue?vue&type=script&lang=js&"
export * from "./setupMfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports